import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
import InlineSVG from 'svg-inline-react';

import { resetPassword } from '../../../store/modules/login';
import classes from './PasswordReset.scss';
import logo from '../../../assets/logo_login.svg';

const style = {
  width: '100%',
  maxWidth: 360,
  margin: '0 auto',
  height: 48,
};

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email:
        typeof props.params.email !== 'undefined' && props.params.email !== null
          ? decodeURIComponent(props.params.email)
          : '',
      emailReadonly:
        typeof props.params.email !== 'undefined' &&
        props.params.email !== null,
      password: '',
      password_confirmation: '',
      forgot: false,
      forgotSubmitted: false,
      token: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      token: nextProps.params.token,
      email: decodeURIComponent(nextProps.params.email),
      emailReadonly: true,
    });

    if (nextProps.login.isAuthenticated) {
      window.location = `${window.location.origin}/dashboard`;
    }
  }

  checkSubmit = event => {
    if (event.keyCode === 13) {
      this.login();
    }
  };

  login = () => {
    this.props.resetPassword(
      this.state.email,
      this.state.password,
      this.state.password_confirmation,
      this.props.params.token,
    );
  };

  render() {
    return (
      <div className={`scss-flex-grid ${classes.login}`}>
        <div className="col-xs-8 text-center">
          <InlineSVG src={logo} className={classes.logo} />
          <br />
          <form
            className="comment-form"
            formAction="login"
            onSubmit={event => {
              event.preventDefault();
              this.login();
            }}
          >
            <input
              type="text"
              className={`${classes.email} ${
                this.state.emailReadonly ? '' : 'hide'
              }`}
              readOnly
              hidden={!this.state.emailReadonly}
              value={`E-Mail: ${this.state.email}`}
            />
            <input
              type="email"
              placeholder="E-Mail-Adresse"
              className={`${classes.email} ${
                this.state.emailReadonly ? 'hide' : ''
              }`}
              readOnly={this.state.emailReadonly}
              hidden={this.state.emailReadonly}
              value={this.state.email}
              onChange={event => {
                this.setState({ email: event.target.value });
              }}
              onKeyDown={e => this.checkSubmit(e)}
            />
            <br />
            <input
              type="password"
              placeholder="Neues Passwort"
              onChange={event => {
                this.setState({ password: event.target.value });
              }}
              onKeyDown={e => this.checkSubmit(e)}
            />
            <br />
            <input
              type="password"
              placeholder="Neues Passwort bestätigen"
              onChange={event => {
                this.setState({ password_confirmation: event.target.value });
              }}
              onKeyDown={e => this.checkSubmit(e)}
            />
            <br />
            <RaisedButton
              label="Passwort ändern"
              primary
              style={style}
              onClick={() => this.login()}
            />
          </form>
        </div>
      </div>
    );
  }
}
PasswordReset.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  login: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  params: PropTypes.object,
  location: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
};
PasswordReset.contextTypes = {
  store: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  login: state.login,
});
const mapActionCreators = {
  resetPassword,
};
export default connect(mapStateToProps, mapActionCreators)(PasswordReset);



// WEBPACK FOOTER //
// ./src/routes/PasswordReset/components/PasswordReset.js